import { EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import { ConnectedDisconnected } from '../enums/ConnectedDisconnected';
import { IStation } from '../models/station';
import { IApiService } from '../services/api_service';

export const station = (siteApi: IApiService) => ({
  index: (params?): Promise<IStation[]> => {
    return siteApi.get('/station', { params })
      .then((stations: IStation[]) => {
        stations = stations.map((s) => {
          s.stationStatus = {
            status: s.stationStatus?.status ?? EnabledDisabled.ENABLED,
            freeswitch: s.stationStatus?.freeswitch ?? ConnectedDisconnected.DISCONNECTED,
            connectServer: s.stationStatus?.connectServer ?? ConnectedDisconnected.DISCONNECTED,
            inCall: s.stationStatus?.inCall ?? false,
            inUse: s.stationStatus?.inUse ?? false
          };
          return s;
        });
        return stations;
      });
  },
  putStatus: (id, newStatus) => {
    return siteApi.put(`/station/status/${id}`, { newStatus });
  },
  putMultipleStatus: (ids, newStatus) => {
    return siteApi.put('/station/multiple/status', {
      ids: ids.join(','),
      newStatus
    });
  }
});
